<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('camera.setting')}}</span>
  </template>

  <v-form ref="form" v-model="validSetting" lazy-validation>
    <name-text-field v-model="nameText"></name-text-field>
    <device-selector v-model="selectedTrigger" :label="$t('camera.select_trigger')" :functypes="triggerTypes" clearable></device-selector>
    <contact-selector v-model="selectedContacts" :label="$t('camera.emails_to_notify')"></contact-selector>
  </v-form>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn color="primary" flat :disabled="!canSave" :loading="saving" @click="save">{{ $t('camera.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import ContactSelector from '@/components/contact/ContactSelector'
import DeviceSelector from '@/components/device/DeviceSelector'
import NameTextField from '@/components/utils/NameTextField'

export default {
  name: 'CameraEditDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    camera: {
      type: Object
    }
  },
  components: {
    'standard-dialog': Dialog,
    'contact-selector': ContactSelector,
    'device-selector': DeviceSelector,
    'name-text-field': NameTextField
  },
  data() {
    return {
      saving: false,
      selectedTrigger: null,
      selectedContacts: [],
      validSetting: false,
      triggerTypes: [13, 14, 16, 17, 20, 21, 22, 23, 24, 25, 27, 28, 31, 36],
      nameText: null
    }
  },
  watch: {
    targetName(val) {
      if (this.saving) {
        if (val == this.nameText) {
          this.visible = false;
        }
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    targetName() {
      return ((this.userTargetName[this.camera.mac] || {})[this.camera.uid] || {})[this.camera.cid]
    },
    canSave() {
      return this.validSetting && (this.nameChanged || this.triggerChanged);
    },
    nameChanged() {
      return this.nameText != this.camera.targetName;
    },
    triggerChanged() {
      return this.selectedTrigger != (this.camera.trigger || {}).trigger ||
        this.selectedContacts != (this.camera.trigger || {}).notify;
    }
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      if (this.nameChanged) this.saveTargetName();
      if (this.triggerChanged) this.saveTrigger();
    },
    async saveTargetName() {
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          cmd: 'settargetname',
          mac: this.camera.mac,
          uid: this.camera.uid,
          cid: this.camera.cid,
          val: this.nameText
        });
      } catch (err) {
        this.$emit('toast', this.$t('device.permission_denied'));
        this.saving = false;
        return;
      }

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.saving = false;
        }
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    },
    async saveTrigger() {
      this.$db.ref('userCastTrigger').child(this.userId).child(this.camera.key).set({
          trigger: this.selectedTrigger || {},
          notify: this.selectedContacts || []
        })
        .then(() => this.visible = false)
        .catch(err => console.log('ERR', err.message));
    }
  },
  mounted() {
    this.$refs.form.reset();
    this.nameText = this.camera.targetName;
    this.selectedTrigger = (this.camera.trigger || {}).trigger;
    this.selectedContacts = (this.camera.trigger || {}).notify;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/CameraEditDialog.vue